/* istanbul ignore file */
/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ThemeProvider } from "@material-ui/core";
import theme from "./theme";
import { LocalizeProvider } from "react-localize-redux";
import TagManager from "react-gtm-module";
import { environment } from "./environments/environment";

const tagManagerArgs = {
  gtmId: environment.gtmId,
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <LocalizeProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </LocalizeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
